import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
// @ts-ignore
import {DataService} from 'projects/firebase/src/lib/services/data.service';
import {SharedService} from 'projects/shared/src/lib/shared.service';
import {mergeMap} from 'rxjs';

@Component({
  selector: 'lib-questionaire',
  templateUrl: './questionaire.component.html',
  styleUrls: ['./questionaire.component.scss']
})
export class QuestionaireComponent implements OnInit {
  @Input() isEng = false;
  @Input() environment: any = null;
  loading = false;
  uploading = false;
  structure: any;
  currentStep: any = null;
  currentStepNumber = 1;

  form = new FormGroup({});
  _data: any;

  steps: { id: number, data: any }[] = [];
  testId: any = null;

  @Input() sid: any = null;
  uid: any = null;

  @Output() questionnaireEnd: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() stepSubmit: EventEmitter<any> = new EventEmitter<any>();

  uploadingText = 'Uploading answers';
  configuringText = 'Configuring questions';
  constructor(
    private dataService: DataService,
    private service: SharedService,
    private el: ElementRef
  ) {
  }

  ngOnInit(): void {
    this.uploadingText =  this.isEng ? 'Uploading answers' : 'Завантаження відповідей';
    this.configuringText =  this.isEng ? 'Configuring questions' : 'Налаштування запитань';

    this.loading = true;
    this.dataService.getSession(this.sid)
    .pipe(
      mergeMap((res) => {
        const {test, uid} = res;
        this.uid = uid;
        this.testId = test;
        return this.dataService.getQuestionnaire(this.environment.apiUrl, this.testId);
      })
    )
    .subscribe((res: { questionnaire: any[], entryPoint: string }) => {
      this.structure = res.questionnaire;
      this.showStep(res.entryPoint);
      this.loading = false;

    });
  }

  get data() {
    return this._data;
  }

  set data(prop: any) {
    this._data = prop;
  }

  showStep(stepNumber: any) {
    this.steps.push({
      id: stepNumber,
      data: []
    });
    this.currentStepNumber = stepNumber;
    this.currentStep = null;
    this.form.markAsUntouched();
    this.form.markAsPristine();
    this.data = {};
    const nextStep = this.structure.find((item: any) => item.id === stepNumber);
    if (nextStep && nextStep.end) {
      this.uploading = true;
      this.dataService.saveFormResult(this.uid, this.sid, 'form', this.steps)
      .then(() => this.service.waitUntil(1000))
      .then(() => {
        return this.questionnaireEnd.emit(true);
      });
    } else {
      setTimeout(() => {
        this.currentStep = nextStep;
      }, 100);
    }

  }

  setDefault() {
    this.currentStep.questions.forEach((el: any, i: number) => {
      this.data[el.key] = el.templateOptions.options[0].value;
      this.form.patchValue(this.data);
    });
  }

  showPrevStep() {
    this.steps.pop();
    const previousStep = this.steps[this.steps.length - 1];

    this.currentStepNumber = previousStep.id;
    this.currentStep = null;

    setTimeout(() => {
      this.form = new FormGroup({});
      this.data = previousStep.data;
      this.currentStep = this.structure.find((item: any) => item.id === previousStep.id);
    }, 100);
  }

  submit() {
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      this.scrollToFirstInvalidControl();
      return;
    }
    this.stepSubmit.next('proceed_' + this.currentStepNumber);

    // tslint:disable-next-line:no-non-null-assertion
    this.steps.find(el => el.id === this.currentStepNumber)!.data = this.data;
    this.showStep(this.currentStep.type === 'test' ? this.currentStep.targetId : this.data[Object.keys(this.data)[0]]);
    // const form: HTMLElement = this.el.nativeElement.querySelector(
    //   'form'
    // );
    // this.scroll(form, 0);
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }

  scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      'form .ng-invalid'
    );
    this.scroll(firstInvalidControl, 0);

  }

  scroll(controlEl: HTMLElement, top: number) {
    window.scroll({
      top: controlEl.getBoundingClientRect().top,
      left: 0,
      behavior: 'auto'
    });
  }

  getTopOffset(controlEl: HTMLElement, top: number): number {
    return controlEl.getBoundingClientRect().top + window.scrollY - top;
  }
}
